import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

export function ConnectionRow({
  icon: Icon,
  iconClassName,
  title,
  subtitle,
  badge,
  actions,
}: {
  icon: LucideIcon;
  iconClassName?: string;
  title: string;
  subtitle?: string;
  badge?: ReactNode;
  actions: ReactNode;
}) {
  return (
    <div className="flex items-center justify-between gap-3 rounded-lg border px-4 py-3">
      <div className="flex min-w-0 items-center gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-muted">
          <Icon className={iconClassName ?? "h-4 w-4"} />
        </div>
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <p className="truncate text-sm font-medium">{title}</p>
            {badge}
          </div>
          {subtitle && (
            <p className="truncate text-xs text-muted-foreground">{subtitle}</p>
          )}
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-1">{actions}</div>
    </div>
  );
}
